import React from 'react';
import { MasterLayout } from 'layout';
import { browserHistory } from 'react-router';
import { HandleLettersOld } from 'modules/handle-letters-old';
import cookie from 'react-cookie';
import {Danhmuc} from 'api';

export default class HandleLettersOldPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      dataThamSo: []
    }
  }

  componentWillMount() {
    if (typeof cookie.load('accessToken') === 'undefined') {
      browserHistory.push('/dang-nhap');
    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <HandleLettersOld param={this.props.params} />
      </MasterLayout>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/pages/handle-letters-old/HandleLettersOldPage.jsx